import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureListing } from '../../util/data';
import { EditListingFeaturesForm } from '../../forms';
import { ListingLink } from '../../components';

import css from './EditListingFeaturesPanel.module.css';
import './customEditListing.css';

const FEATURES_NAME = 'yogaStyles';

const EditListingFeaturesPanel = props => {
  const {
    rootClassName,
    className,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    selectedFeature,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const { publicData } = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingFeaturesPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingFeaturesPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingFeaturesPanel.createListingTitle" />
  );

  const yogaStyles = publicData && publicData.yogaStyles;
  const servicePriceD = publicData && publicData.servicePrice;
  const initialValues = { yogaStyles };
  return (
    <div className={`${classes} mainServicesform`}>
      <h1 className={css.title}>{panelTitle}</h1>
      <p>Price per hour in dollars - keep in mind  Worship Serve charges a 25% marketing and processing fee</p>
      <EditListingFeaturesForm
        className={css.form}
        name={FEATURES_NAME}
        initialValues={
          selectedFeature?.length > 0 ? { yogaStyles: selectedFeature } : initialValues
        }
        servicePriceD={servicePriceD}
        onSubmit={values => {
          // written by BK
          // if (values['yogaStyles'].includes('worship_leader')) {
          //   values['yogaStyles'] = ['worship_leader'];
          // }
          // for old chnages remove above
          const { yogaStyles = [] } = values;
          const { servicePrice = [] } = values;

          const updatedValues = {
            publicData: { yogaStyles, servicePrice },
          };
          onSubmit(updatedValues);
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingFeaturesPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listing: null,
};

const { bool, func, object, string } = PropTypes;

EditListingFeaturesPanel.propTypes = {
  rootClassName: string,
  className: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingFeaturesPanel;
